/**
 * SKUS LOG
 */

// React
import React, { useEffect, useState } from 'react';

import { getAllInventoryItemLogs } from 'client-sdk/src/allLogs/allLogs';
import { GetAllInventoryItemsRequestBuilder } from 'client-sdk/src/warehouses/warehouses';
import Client from 'client-sdk/src/client';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Grid,
  Button,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiArrowRight,
  mdiCounter,
  mdiWarehouse,
  mdiArchiveOutline,
  mdiVectorPolylineEdit,
  mdiMapMarkerCheckOutline,
  mdiClose,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiPlaylistCheck,
  mdiCheckBold,
  mdiArrowCollapseAll,
  mdiFileTree,
  mdiClipboardArrowLeft,
  mdiTableArrowUp,
  mdiTableCheck, mdiPackageVariantClosed,
} from '@mdi/js';

// Type
import {
  PropsWarehouseInventoryHistory,
} from './interfaces';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { Log } from '../parcels/interfaces';
import theme from '../../theme';
import jMoment from 'moment-jalaali';
import { translate } from '../../utils/helpers';
import handleError from '../../utils/handleError';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    wastageTitleBox: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CHECKED: mdiPackageVariantClosed, // بسته بندی شده
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // بارگذاری شده
  PICKED: mdiDotsHorizontalCircleOutline, // برداشته شده
  NOT_REGISTERED: mdiTableArrowUp, // رجیستر نشده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'بارگذاری شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
  PICKED: theme.palette.green.main, // برداشته شده
  CHECKED: theme.palette.secondary.main, // بسته بندی شده
  NOT_REGISTERED: theme.palette.orange.main, // رجیستر نشده
};

export function WarehouseInventoryLogs(props: PropsWarehouseInventoryHistory) {
  const classes = useStyles();
  const token = localStorage.getItem('token') || '';
  const [logData, setLogData] = useState<any>(null);
  const [inventoryItem, setInventoryItem] = useState<any>(null);

  useEffect(() => {
    const { id } = props.match.params;
    getInventoryItemById(id);
    getInventoryItemLog();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getInventoryItemLog = async () => {
    try {
      const makeReq = new getAllInventoryItemLogs()
        .params({ 'inventoryItemId.equals': props.match.params.id })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeReq);
      setLogData(data);
    } catch (err) {
      handleError(err.response);
    }
  };

  const getInventoryItemById = async (id: number) => {
    try {
      const makeRequest = new GetAllInventoryItemsRequestBuilder()
        .id(id)
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setInventoryItem(data);
    } catch (e) {
      handleError(e.response);
    }
  };

  // GetAllInventoryItemsRequestBuilder

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
        تاریخچه تغییر وضعیت آیتم
        `}
            </Typography>
            <span className={classes.contentlabelTitle}>
              {props.match.params?.id}
            </span>
          </div>

          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>
      </Grid>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام شرکت:  `}
              </span>

              <span>{inventoryItem?.partnerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiArchiveOutline}
                  size={1}
                  className={classes.icon}
                />
                {`نام کالا:  `}
              </span>

              <span>{inventoryItem?.productName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {`کد کالا:  `}
              </span>
              <span>{inventoryItem?.productCode}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {`سریال کالا:  `}
              </span>
              <span>{inventoryItem?.serialNumber}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه تنوع:  `}
              </span>
              <span>{inventoryItem?.variantId}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {`شناسه محموله:  `}
              </span>
              <span>{inventoryItem?.parcelId}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiVectorPolylineEdit}
                  size={1}
                  className={classes.icon}
                />
                {`فروشنده/تامین‌کننده:  `}
              </span>
              <span>
                {inventoryItem?.providerName
                  ? inventoryItem?.providerName
                  : inventoryItem?.sellerName}
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={4}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiVectorPolylineEdit}
                  size={1}
                  className={classes.icon}
                />
                {`کد فروشنده/تامین‌کننده:  `}
              </span>
              <span>
                {inventoryItem?.providerId
                  ? inventoryItem?.providerId
                  : inventoryItem?.sellerId}
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container>
        <Grid item xs={12}>
          <Timeline align="left">
            {logData
              ?.slice()
              .reverse()
              .map((log: Log, index: number) => (
                <TimelineItem
                  className={classes.missingOppositeContent}
                  key={index}
                >
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: colorStatus[log?.newStatus],
                        borderColor:
                          index === 0 ? theme.palette.secondary.main : '',
                      }}
                    >
                      <Icon path={iconStatus[log?.newStatus]} size={1} />
                    </TimelineDot>
                    {index !== logData?.length - 1 ? <TimelineConnector /> : ''}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper elevation={3} className={classes.paperHistory}>
                      <Typography
                        component="div"
                        className={
                          log?.wastage
                            ? classes.wastageTitleBox
                            : classes.titleBox
                        }
                      >
                        {log?.time &&
                          jMoment(log?.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                      <div className={classes.contentBox}>
                        <Grid
                          container
                          justify="space-between"
                          alignItems="center"
                        >
                          <div>
                            <span className={classes.contentlabel}>
                              وضعیت آیتم:
                            </span>
                            <span>
                              {translate(log?.newStatus, 'parcel')}
                            </span>
                          </div>
                          {log?.wastage && (
                            <div style={{ color: 'red' }}>{'انبار ضایعات'}</div>
                          )}
                        </Grid>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>کاربر:</span>
                          <span>{log?.modifierName}</span>
                          <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                          <span>{translate(log?.modifierRole, 'user')}</span>
                        </div>
                        {log?.description && (
                          <div style={{ marginTop: '12px' }}>
                            <span className={classes.contentlabel}>
                              توضیحات:
                            </span>
                            <span>{log?.description}</span>
                          </div>
                        )}
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>
                            آدرس یونیت:
                          </span>
                          <span style={{ display: 'inline-block' }}>
                            {log?.unitCode}
                          </span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>
                            سریال کالا:
                          </span>
                          <span>{inventoryItem?.serialNumber}</span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>
                            شناسه سفارش:
                          </span>
                          <span>{log?.orderId}</span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>توضیحات:</span>
                          <span>{log?.description}</span>
                        </div>
                      </div>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </Grid>
      </Grid>
    </div>
  );
}

// const mapStateToProps = createStructuredSelector<Store,
//   SelectorPropsWarehouseInventoryHistory>({
//   variant: makeSelectVariant(),
//   loading: makeSelectLoading(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     getVariantDispatch: (id: number) =>
//       dispatch(getVariantAction({id})),
//     getParcelsItemsDispatch: (payload: object) =>
//       dispatch(getParcelsItemsAction(payload)),
//   };
// }

// const withConnect = connect(mapStateToProps, mapDispatchToProps);
// // @ts-ignore
export default WarehouseInventoryLogs;
